export enum NOTICE_TYPE {
    PARTNERSHIP = 'partnership',
}

export enum PAGE_KEY {
    BROWSE_CERTIFICATION_ISSUER_AGGREGATOR = 'browse_certification_issuer_aggregator',
    BROWSE_CERTIFICATION_SUBJECT_AGGREGATOR = 'browse_certification_subject_aggregator',
}
